module.exports = __webpack_public_path__ + "media/images/massage/main_image2@3x-5e75363325a4c5c6bf400d3e5f08c33a.jpg";